import { createFileRoute } from "@tanstack/react-router";
import MakeModelPage from "@/pages/MakeModelPage";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/uk/cars/$make/$model/")({
  head: ({ params }) => routeHead("/uk/cars/$make/$model/", params as Record<string, string>),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <MakeModelPage />
  );
}
